export default {
  user: {
    id: '',
    name: '',
    email: '',
    roles: [],
  },
};
